module.exports = __webpack_public_path__ + "static/img/4_4_2.a5c098b8.jpg";